import { axiosInstanceAnalytics, axiosInstanceAnalyticsExperiments, axiosInstanceWebsite } from "../instance";
import { decodeTokenService } from "../decodeTokenService";
import { AxiosResponse } from "axios";

export interface ExperimentsListBulkPayload {
    owner_id: string;
    website_id: string;
    experiment_ids: number[];
}
export interface ExperimentsStatsPayload {
    owner_id: string;
    website_id: string;
    experiment_ids: number[];
}

export interface GetDetailExperimentForFunnelPayload {
    owner_id: string;
    website_id: string;
    experiment_id: number;
    experiment_variant_names: string[];
}
export interface CreateExperimentPayload {
    website_id: string;
    product_id: string;
    name: string;
    base_price: number;
    variants: Variant[];
}

export interface UpdateExperimentPayload {
    name?: string;
    status: string;
    variants?: Variant[];
}

export interface Variant {
    name: string;
    price: number;
    traffic_percentage: number;
}

export const getExperimentsForUser = async () => {
    const token = decodeTokenService.getToken();
    const headers = {
        "Authorization": `Bearer ${token}`,
    };
    const response: AxiosResponse = await axiosInstanceAnalyticsExperiments.get(
        `/experiments`,
        { headers }
    );
    return response.data;
};

export const getStatasExperimentsForUser = async (data: ExperimentsStatsPayload) => {
    const response: AxiosResponse = await axiosInstanceAnalytics.post(
        `/experiments-list`,
        data,
    );
    return response.data;
};

export const postCreateExperiment = async (data: CreateExperimentPayload) => {
    const token = decodeTokenService.getToken();
    const headers = {
        "Authorization": `Bearer ${token}`,
    };
    const response: AxiosResponse = await axiosInstanceAnalyticsExperiments.post(
        `/experiments`,
        data,
        { headers }
    );
    return response.data;
};

export const putUpdateExperiment = async (experimentId: string, data: UpdateExperimentPayload) => {
    const token = decodeTokenService.getToken();
    const headers = {
        "Authorization": `Bearer ${token}`,
    };
    const response: AxiosResponse = await axiosInstanceAnalyticsExperiments.put(
        `/experiments/${experimentId}`,
        data,
        { headers }
    );
    return response.data;
};

export const postBulkUpsertExperiments = async (productId: string) => {
    const token = decodeTokenService.getToken();
    const headers = {
        "Authorization": `Bearer ${token}`,
    };
    const response: AxiosResponse = await axiosInstanceWebsite.post(
        `/offer/bulk-upsert/${productId}`,
        [],
        { headers }
    );
    return response.data;
};

export const getDetailExperimentForFunnel = async (data: GetDetailExperimentForFunnelPayload) => {
    const response: AxiosResponse = await axiosInstanceAnalytics.post(
        `/experiment-metrics`,
        data
    );
    return response.data;
};

export const getExperimentsListBulk = async (data: ExperimentsListBulkPayload[]) => {
    const response: AxiosResponse = await axiosInstanceAnalytics.post(
        `/experiments-list-bulk`,
        data
    );
    return response.data;
};